import React, { useState, useEffect, useRef } from "react";
import "./otpStyle.css";

const OTP = ({ onVerifyOtp }) => {
  const [otp, setOtp] = useState("");
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  // Handle keyup to move focus and update OTP value
  const handleKeyUp = (event, index) => {
    const input = inputRefs[index].current;
    const code = parseInt(input.value);

    if (code >= 0 && code <= 9) {
      const nextInput = inputRefs[index + 1]?.current;
      if (nextInput) {
        nextInput.focus();
      }
    } else {
      input.value = "";
    }

    if (event.key === "Backspace" || event.key === "Delete") {
      const prevInput = inputRefs[index - 1]?.current;
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  // Update OTP value on change
  const handleChange = () => {
    const otpValue = inputRefs.map((ref) => ref.current.value).join("");
    setOtp(otpValue);
  };

  // // Handle OTP verification
  // const handleSubmit = async () => {
  //   setIsVerifyingOtp(true);
  //   try {
  //     await onVerifyOtp();
  //   } catch (error) {
  //     console.error('Error during OTP verification', error);
  //   } finally {
  //     setIsVerifyingOtp(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check if OTP has 5 digits
    if (otp.length === 5) {
      setIsVerifyingOtp(true); // Start the verification process
  
      try {
        await onVerifyOtp(otp); // Call the parent method for OTP verification
      } catch (error) {
        console.error('Error during OTP verification', error);
      } finally {
        setIsVerifyingOtp(false); // Stop the verification process
      }
    } else {
      alert("Please enter a valid 5-digit OTP."); // Show alert if OTP is not valid
    }
  };
  
  return (
    <section className="otp text-center">
      <aside class="notification">
        <div class="notification-content">
          <h4> Vérification requise</h4>
          <span>
            Un code de vérification a été envoyé à{" "}
            <strong>votre adresse e-mail</strong>. Veuillez vérifier votre boîte
            de réception et suivre les instructions pour continuer.
          </span>
        </div>
      </aside>
      <div className="title text-center mb-4 mt-4">Verification Code</div>

      {inputRefs.map((ref, index) => (
        <input
          key={index}
          ref={ref}
          type="text"
          maxLength="1"
          onChange={handleChange}
          onKeyUp={(event) => handleKeyUp(event, index)}
        />
      ))}

      <button
        onClick={handleSubmit}
        className="btn login-btn mt-3"
        disabled={isVerifyingOtp}
      >
        {isVerifyingOtp ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Vérification OTP
          </>
        ) : (
          "Vérifier OTP"
        )}
      </button>
    </section>
  );
};

export default OTP;
